import request from '@/router/axios';

export const getDictionary = (params) => {
  return request({
    url: '/api/blade-system/dict/dictionary',
    method: 'get',
    params,
  })
}

export const mobileRouters = () => {
  return request({
    url: '/api/blade-system/menu/mobile-routes',
    method: 'get',
    params: {
      platformType: 2
    },
  });
};



// WEBPACK FOOTER //
// ./src/api/dict.js